import {Button} from '@wandb/weave/components/Button/Button';
import React, {FC, useState} from 'react';

type OverlaysTableProps = {
  isAllVisible: boolean;
  setIsAllVisible: (isAllVisible: boolean) => void;
  title: string;
  rightContent?: React.ReactNode;
};

export const OverlaysTable: FC<OverlaysTableProps> = ({
  isAllVisible,
  setIsAllVisible,
  title,
  children,
  rightContent,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <div className="flex flex-col pt-4">
      <div className="flex h-32 items-center justify-between">
        <div className="flex items-center">
          <Button
            data-test="visibility-toggle-all"
            className="ml-8"
            variant="ghost"
            icon={isAllVisible ? 'visible' : 'not-visible'}
            onClick={() => setIsAllVisible(!isAllVisible)}
          />
          <div className="font-semibold">{title}</div>
          <Button
            variant="ghost"
            icon={isExpanded ? 'chevron-down' : 'chevron-next'}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
        {rightContent}
      </div>
      {isExpanded && children != null && (
        <div className="mt-4 rounded px-8 py-16 outline outline-moon-200">
          {children}
        </div>
      )}
    </div>
  );
};
